(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gt-compatibility"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gt-compatibility')) {
  customElements.define('gt-compatibility', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const rows = Array.from(this.querySelectorAll('[data-fitment-row]'));
      const button = this.querySelector('button');
      const initial = Number(this.dataset.initial) || 10;
      if (!rows.length || !button) return;
      this.dataset.ready = 'true';
      const notes = rows.map(row => row.querySelector('.gt-compatibility__notes'));
      if (!notes.some(cell => cell && cell.textContent.trim())) {
        this.querySelectorAll('.gt-compatibility__notes').forEach(cell => cell.hidden = true);
      }
      if (rows.length <= initial) return;
      const update = expanded => {
        rows.forEach((row, index) => row.hidden = !expanded && index >= initial);
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? button.dataset.less : button.dataset.more;
      };
      update(true);
      button.hidden = false;
      button.addEventListener('click', () => update(button.getAttribute('aria-expanded') !== 'true'));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gt-specifications"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gt-oem-list')) {
  customElements.define('gt-oem-list', class extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.gt-oem__numbers');
      this.button = this.querySelector('.gt-oem__toggle');
      if (!this.list || !this.button) return;
      if (!this.list.classList.contains('is-enhanced')) {
        const numbers = this.list.textContent.trim().split(/,\s*/).filter(Boolean);
        const fragment = document.createDocumentFragment();
        numbers.forEach((number, index) => {
          const item = document.createElement('span');
          item.className = 'gt-oem__item';
          item.append(document.createTextNode(number));
          if (index < numbers.length - 1) {
            const separator = document.createElement('span');
            separator.className = 'gt-oem__separator';
            separator.textContent = ', ';
            item.append(separator);
          }
          fragment.append(item);
        });
        this.list.replaceChildren(fragment);
        this.list.classList.add('is-enhanced');
      }
      this.items = Array.from(this.list.querySelectorAll('.gt-oem__item'));
      this.list.append(this.button);
      this.expanded = this.button.getAttribute('aria-expanded') === 'true';
      this.onToggle = () => {
        this.expanded = !this.expanded;
        this.measure();
      };
      this.button.addEventListener('click', this.onToggle);
      this.observer = new ResizeObserver(entries => {
        const width = entries[0].contentRect.width;
        if (width > 0 && width !== this.lastWidth) {
          this.lastWidth = width;
          this.measure();
        }
      });
      this.observer.observe(this.list);
      this.measure();
      document.fonts.ready.then(() => { if (this.isConnected) this.measure(); });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.onToggle);
    }
    measure() {
      if (!this.list.clientWidth || !this.items.length) return;
      this.items.forEach(item => {
        item.hidden = false;
        item.classList.remove('is-last-visible');
      });
      this.button.hidden = true;
      const top = this.items[0].getBoundingClientRect().top;
      const firstRowCount = this.items.filter(item => Math.abs(item.getBoundingClientRect().top - top) < 1).length;
      const overflowing = firstRowCount < this.items.length;
      if (!overflowing) this.expanded = false;
      this.button.hidden = !overflowing;
      this.button.setAttribute('aria-expanded', String(this.expanded));
      this.button.setAttribute('aria-label', this.expanded ? this.button.dataset.less : this.button.dataset.more);
      this.button.querySelector('.gt-oem__label').textContent = this.expanded ? this.button.dataset.less : this.button.dataset.more;
      this.button.querySelector('.gt-oem__label-short').textContent = this.expanded ? this.button.dataset.less : this.button.dataset.short;
      if (overflowing && !this.expanded) {
        const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
        let usedWidth = this.button.getBoundingClientRect().width;
        let visibleCount = 0;
        for (const item of this.items) {
          const nextWidth = usedWidth + gap + item.getBoundingClientRect().width;
          if (nextWidth > this.list.clientWidth) break;
          usedWidth = nextWidth;
          visibleCount += 1;
        }
        visibleCount = Math.max(1, visibleCount);
        this.items.forEach((item, index) => { item.hidden = index >= visibleCount; });
        this.items[visibleCount - 1].classList.add('is-last-visible');
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
